import { setClassName } from '@change-corgi/core/error';

import { UploadError } from './uploadError';

/**
 * An UploadError that Uppy itself should treat as a restriction failure (mirroring its own
 * `RestrictionError`'s `isRestriction` flag). Uppy's `#informAndEmit` checks this flag on any
 * error reaching `upload()` — including one thrown from a custom preprocessor — and emits
 * `restriction-failed` instead of the generic `error` event, routing it through the same
 * `restriction-failed` listener (registered in useUploader) that already maps other restriction
 * failures to a translated error key, rather than needing a second, ad-hoc handling path.
 */
export class RestrictionUploadError extends UploadError {
	readonly isRestriction = true;
}
setClassName(RestrictionUploadError, 'RestrictionUploadError');
